import { Label } from "Components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "Components/ui/select";

function DropdownInput({
  value,
  setValue,
  required,
  placeholder,
  data,
  label,
  disabled,
}) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label className="text-sm">{label}</Label>
      <Select
        value={value}
        onValueChange={(e) => (e || e == 0) && setValue(e)}
        required={required}
        disabled={disabled}
      >
        <SelectTrigger
          className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-border py-5 rounded-lg focus:outline-none focus:ring-0 focus:border-border "
          style={{
            color:
              value || value == 0 ? "var(--white)" : "var(--white-opacity)",
          }}
        >
          {value != "" && value && value != 0 ? (
            <SelectValue />
          ) : (
            <span className="text-white-opacity">{placeholder}</span>
          )}
        </SelectTrigger>
        <SelectContent>
          {data.map((item) => (
            <SelectItem key={item.value} value={item.value || 0}>
              <div className="flex items-center gap-4 p-1">
                <p>{item.label}</p>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default DropdownInput;
